module.exports = __webpack_public_path__ + "static/media/transaction-selected.1b3b7992.svg";